import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-toastify/dist/ReactToastify.css';

import logo from './logo.svg';
import './App.css';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import Footer from './components/Footer';
import Login from './pages/Login';
import About from './pages/About';
import Register from './pages/Register';
import Appointments from './pages/Appointments';
import Contact from './pages/Contact';
import GdTokens from './pages/GdTokens';
import EditProfile from './pages/EditProfile';
import Partners from './pages/Partners';
import Test from './pages/Test';
import Partner from './pages/Partner';
import ForgotPassword from './pages/ForgotPassword';
import Products from './pages/Products';
import AccountHistory from './pages/AccountHistory';
import BecomePartner from './pages/BecomePartner';
import Referrals from './pages/Referrals';
import Demat from './pages/Demat';
import ResetPassword from './pages/ResetPassword';
import Payouts from './pages/Payouts';

import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer />
      <NavBar />
      <Routes>
        <Route exact key="home" path="/" element={<Home />} />
        <Route exact key="login" path="/login" element={<Login />} />
        <Route exact key="register" path="/register" element={<Register />} />
        <Route exact key="forgot" path="/forgot" element={<ForgotPassword />} />
        <Route exact key="reset-password" path="/reset-password/:resetPasswordToken" element={<ResetPassword />} />
        <Route exact key="about" path="/about" element={<About />} />
        <Route exact key="appointments" path="/appointments" element={<Appointments />} />
        <Route exact key="contact" path="/contact" element={<Contact />} />
        <Route exact key="gt" path="/gt" element={<GdTokens />} />
        <Route exact key="profile" path="/profile" element={<EditProfile />} />
        <Route exact key="partnership" path="/partnership" element={<BecomePartner />} />
        <Route exact key="payouts" path="/payouts" element={<Payouts />} />
        {/* <Route exact key="demat" path="/demat" element={<Demat />} /> */}
        <Route exact key="partners" path="/partners" element={<Partners />} />
        <Route exact key="products" path="/products" element={<Products />} />
        <Route exact key="history" path="/history" element={<AccountHistory />} />
        <Route exact key="referrals" path="/referrals" element={<Referrals />} />
        <Route exact key="partner/:id" path="/partner/:id" element={<Partner />} />
        <Route exact key="test" path="/test" element={<Test />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
